<script setup lang="ts">
import SectionHeader from '../../common/SectionHeader.vue'

interface QuickFacts {
  'Type'?: string
  'When'?: string
  'Roles most tested'?: string
  [key: string]: any
}

interface Props {
  quickFacts?: QuickFacts
  companyName: string
}

const props = defineProps<Props>()
</script>

<template>
  <section class="bg-white mb-8">
    <SectionHeader
      title="Quick Facts"
      class="mb-6"
    />
    <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <div class="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <p class="text-sm font-medium text-slate-500">
          Does {{ companyName }} drug test?
        </p>
        <p class="mt-1 text-lg font-semibold">
          {{ quickFacts?.[`Does ${companyName} drug test?`] || 'Varies by role' }}
        </p>
      </div>
      <div class="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <p class="text-sm font-medium text-slate-500">
          Type
        </p>
        <p class="mt-1 text-lg font-semibold">
          {{ quickFacts?.Type || 'Not specified' }}
        </p>
      </div>
      <div class="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <p class="text-sm font-medium text-slate-500">
          When
        </p>
        <p class="mt-1 text-lg font-semibold">
          {{ quickFacts?.When || 'Not specified' }}
        </p>
      </div>
      <div class="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <p class="text-sm font-medium text-slate-500">
          Roles most tested
        </p>
        <p class="mt-1 text-lg font-semibold">
          {{ quickFacts?.['Roles most tested'] || 'Not specified' }}
        </p>
      </div>
    </div>
  </section>
</template>
